document.addEventListener('DOMContentLoaded', function () {
  var comments = document.getElementById('comments');
  var ref = document.getElementById('shopify-section-template--15980214649012__3b17313e-0385-4ac0-b5f3-a0934471a7f6');
  var blogPosts = document.getElementById('shopify-section-template--15980214649012__blog-posts');
  var backBtn = document.querySelector('.back-to-learn-button');

  if (comments && ref) ref.after(comments);

  if (comments) {
    var wrapper = document.createElement('div');
    wrapper.className = 'page-width';
    comments.parentNode.insertBefore(wrapper, comments);
    wrapper.appendChild(comments);
  }

  if (blogPosts && comments) comments.after(blogPosts);
  if (backBtn && comments) comments.after(backBtn);
});
